export const getAtlAttributionHeader = (): {
	'atl-attribution': string;
} => {
	return {
		'atl-attribution': JSON.stringify({
			product: 'Confluence Cloud', // The product to which the upstream service belongs
			service: 'confluence-frontend', // Name of the upstream service
		}),
	};
};
